/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { CameraStreamSettings } from './CameraStreamSettings';
import { ExternalDetectorSettings } from './ExternalDetectorSettings';
import { Status } from './Status';
import { VmsCleanupSettings } from './VmsCleanupSettings';
export type Camera = {
    readonly id: number;
    /**
     * Object creation date
     */
    readonly created_date: string;
    /**
     * Object modification date
     */
    readonly modified_date: string;
    /**
     * Camera group
     */
    group: number;
    /**
     * Processing is active
     */
    active?: boolean;
    /**
     * Short name, up to 256 characters
     */
    name: string;
    /**
     * Extended description, up to 2048 characters
     */
    comment?: string;
    url?: string;
    router_url?: string | null;
    stream_settings?: CameraStreamSettings;
    vms_cleanup_settings?: VmsCleanupSettings | null;
    /**
     * Screenshot URL
     */
    readonly screenshot: string;
    readonly health_status: Status;
    /**
     * Camera latitude
     */
    latitude?: number | null;
    /**
     * Camera longitude
     */
    longitude?: number | null;
    /**
     * Camera azimuth
     */
    azimuth?: number | null;
    /**
     * Related ONVIF camera object
     */
    onvif_camera?: number | null;
    /**
     * Camera face confidence threshold
     */
    face_threshold?: number | null;
    /**
     * Camera body confidence threshold
     */
    body_threshold?: number | null;
    /**
     * Camera car confidence threshold
     */
    car_threshold?: number | null;
    single_pass?: boolean;
    external_detector?: boolean;
    /**
     * Use this token for events creation API
     */
    readonly external_detector_token: string;
    external_detector_settings?: ExternalDetectorSettings;
    meta?: Record<string, any>;
    /**
     * External VMS
     */
    external_vms?: number | null;
    /**
     * External VMS camera id
     */
    external_vms_camera_id?: string | null;
    /**
     * Frame height in pixels
     */
    readonly frame_height: number;
    /**
     * Frame width in pixels
     */
    readonly frame_width: number;
    /**
     * Angle of view of camera in degrees, used for maps
     */
    angle_of_view?: number | null;
    /**
     * Camera pitch, angle to horizon in degrees, used for maps
     */
    pitch?: number | null;
    /**
     * Address, up to 2048 characters
     */
    address?: string;
    error?: string;
};
export const EmptyCamera: Camera = {
    id: 0,
    /**
     * Object creation date
     */
    created_date: '',
    /**
     * Object modification date
     */
    modified_date: '',
    /**
     * Camera group
     */
    group: 0,
    /**
     * Processing is active
     */
    active: true,
    /**
     * Short name, up to 256 characters
     */
    name: '',
    /**
     * Extended description, up to 2048 characters
     */
    comment: '',
    url: '',
    router_url: '',
    stream_settings: undefined,
    vms_cleanup_settings: {} as any,
    /**
     * Screenshot URL
     */
    screenshot: '',
    health_status: {} as any,
    /**
     * Camera latitude
     */
    latitude: null,
    /**
     * Camera longitude
     */
    longitude: null,
    /**
     * Camera azimuth
     */
    azimuth: null,
    /**
     * Related ONVIF camera object
     */
    onvif_camera: null,
    /**
     * Camera face confidence threshold
     */
    face_threshold: null,
    /**
     * Camera body confidence threshold
     */
    body_threshold: null,
    /**
     * Camera car confidence threshold
     */
    car_threshold: null,
    single_pass: false,
    external_detector: false,
    /**
     * Use this token for events creation API
     */
    external_detector_token: '',
    external_detector_settings: undefined,
    meta: {},
    /**
     * External VMS
     */
    external_vms: null,
    /**
     * External VMS camera id
     */
    external_vms_camera_id: '',
    /**
     * Frame height in pixels
     */
    frame_height: 0,
    /**
     * Frame width in pixels
     */
    frame_width: 0,
    /**
     * Angle of view of camera in degrees, used for maps
     */
    angle_of_view: 72,
    /**
     * Camera pitch, angle to horizon in degrees, used for maps
     */
    pitch: null,
    /**
     * Address, up to 2048 characters
     */
    address: '',
};